<div matRipple [matRippleColor]="''" [matRippleCentered]="false">
  <mat-icon class="icon material-symbols-outlined">{{ icon() ?? "question_mark" }}</mat-icon>
  <label>{{ label() }}</label>
  @if (menu()) {
    <mat-icon class="arrow">arrow_right</mat-icon>
  }
</div>
